<template>
  <div class="flex flex-wrap justify-center items-center gap-2">
    <div class="circle" :class="value && 'green'"></div>
    <p>{{ label }}</p>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
    label: {
      type: String,
      default: "0회/10회",
    },
  },
};
</script>

<style lang="scss" scoped>
.circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #EA5455;
  &.green{
    background: #28C76F;
  }
}
</style>
